import React, { useState } from "react"
import Button from "../../../common/blocks/button/Button"
import Icon from "../../../common/blocks/icon/Icon"
import * as classNames from "./SearchField.module.scss"

function SearchCityField(props) {
  const suggestionsVilles = [
    "Auvergne-Rhone-Alpes",
    "Bourgogne-Franche-Comte",
    "Bretagne",
    "Centre-Val-de-Loire",
    "Corse",
    "Grand-Est",
    "Hauts-de-France",
    "Ile-de-France",
    "Normandie",
    "Nouvelle-Aquitaine",
    "Occitanie",
    "Pays-de-la-Loire",
    "Provence-Alpes-Cote-d-Azur",
  ]
  const [filteredSuggestionsItems, setFilteredSuggestionsItems] = useState([])
  const nameChangeHandler = (e) => {
    const userInput = e.currentTarget.value
    props.setName(userInput)
    const filteredSuggestions = suggestionsVilles.filter(
      (suggestion) =>
        suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    )
    setFilteredSuggestionsItems(filteredSuggestions)
    if (!userInput) {
      setFilteredSuggestionsItems([])
    }
  }
  const addFiltredItems = (e) => {
    if (e.keyCode === 13) {
      props.setFiltredItems([...props.filtredItems, e.target.value])
      e.target.value = ""
      props.setName("")
      setFilteredSuggestionsItems([])
    }
  }
  return (
    <div className={`${classNames.searchField} ${"form-control"}`}>
      <label
        htmlFor="citySearch"
        className="sr-only"
      >
        Villes
      </label>
      <input
        type="search"
        name="citySearch"
        id="citySearch"
        placeholder="Ile-de-France"
        autoComplete="on"
        onChange={nameChangeHandler}
        onKeyUp={addFiltredItems}
      />
      <Button aspect="unstyled">
        <Icon
          icon="emplacement"
          color="var(--gris)"
        />
      </Button>
      {filteredSuggestionsItems.length !== 0 && (
        <ul className={classNames.ulAutocomplete}>
          {filteredSuggestionsItems.map((item, index) => {
            return (
              <li
                key={index}
                onClick={() => {
                  props.setFiltredItems([...props.filtredItems, item])
                  setFilteredSuggestionsItems([])
                }}
                onKeyDown={() => {
                  props.setFiltredItems([...props.filtredItems, item])
                  setFilteredSuggestionsItems([])
                }}
              >
                {item}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default SearchCityField
